/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import _ from 'lodash'
import '../common/helpers';
import '../frontend/components/microsite/helpers.js'

window.Vue = Vue
window.BootstrapVue = BootstrapVue
Vue.use(BootstrapVue)

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

import iframeResize from 'iframe-resizer/js/iframeResizer';
Vue.directive('resize', {
  bind: function(el, { value = {} }) {
    el.addEventListener('load', () => iframeResize(value, el))
  },
  unbind: function (el) {
    el.iFrameResizer.removeListeners();
  }
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('subscribe-component', require('./components/SubscribeComponent.vue').default)
Vue.component('description-more', require('./../common/components/DescriptionMore.vue').default)
Vue.component('package-category-tabs', require('./components/microsite/PackageCategoryTabs.vue').default)
Vue.component('package-category-modal', require('./components/package/PackageCategoryModal.vue').default)
Vue.component('package-tabs', require('./components/microsite/PackageTabs.vue').default)
Vue.component('cart-link', require('./components/microsite/CartLink.vue').default)
Vue.component('checkout-tabs', require('./components/microsite/CheckoutTabs.vue').default)
Vue.component('products-tabs', require('./components/microsite/ProductsTabs.vue').default)
Vue.component('ecommerce-tabs', require('./components/microsite/EcommerceTabs.vue').default)
Vue.component('Tab', require('./components/microsite/Tab.vue').default)
Vue.component('ChildTab', require('./components/microsite/Tab.vue').default)
Vue.component('dollar', require('./components/billing/Dollar.vue').default)
Vue.component('admin-panel', require('./components/microsite/AdminPanel.vue').default)
Vue.component('toggle-design-mode-button', require('./components/microsite/ToggleDesignModeButton.vue').default)
Vue.component('my-account', require('./components/client/MyAccount.vue').default)
Vue.component('checkout-form', require('./components/checkout-form/CheckoutForm.vue').default)
Vue.component('client-top-nav-menu', require('./components/client/ClientTopNavMenu.vue').default)
Vue.component('events-schedule', require('./components/class/EventsSchedule.vue').default)
Vue.component('form-iframe-modal', require('./components/microsite/FormIframeModal.vue').default)
Vue.component('video-wrapper', require('./components/microsite/VideoWrapper.vue').default)
Vue.component('class-register-modal', require('./components/microsite/ClassRegisterModal.vue').default)
Vue.component('class-register', require('./components/microsite/ClassRegister.vue').default)
Vue.component('page-i-calendar-modal', require('./components/microsite-designer/PageICalendarModal.vue').default)
Vue.component('ai-assistant-modal', require('./components/microsite/AiAssistantModal.vue').default)

// Microsite designer (admin stuff) - consider splitting this into a separate bundle
Vue.component('side-nav-pages', require('./components/microsite-designer/SideNavPages.vue').default)
Vue.component('side-nav-search', require('./components/microsite-designer/SideNavSearch.vue').default)
Vue.component('page-design', require('./components/microsite-designer/PageDesign.vue').default)
Vue.component('page-calendar-block', require('./components/microsite-designer/PageCalendarBlock.vue').default)
Vue.component('page-form-answers-block', require('./components/microsite-designer/PageFormAnswersBlock.vue').default)
Vue.component('product-quick-edit-modal', require('./components/microsite-designer/ProductQuickEditModal.vue').default)
Vue.component('page-team-standings-block', require('./components/microsite-designer/PageTeamStandingsBlock.vue').default)
Vue.component('page-teams-schedule-block', require('./components/microsite-designer/PageTeamsScheduleBlock.vue').default)
Vue.component('page-player-stats-block', require('./components/microsite-designer/PagePlayerStatsBlock.vue').default)
Vue.component('page-attendance-block', require('./components/microsite-designer/PageAttendanceBlock.vue').default)
Vue.component('page-radio-buttons-block', require('./components/microsite-designer/PageRadioButtonsBlock.vue').default)
Vue.component('page-search-block', require('./components/microsite-designer/PageSearchBlock.vue').default)
Vue.component('page-alert-block', require('./components/microsite-designer/PageAlertBlock.vue').default)
Vue.component('page-tabs-block', require('./components/microsite-designer/PageTabsBlock.vue').default)
Vue.component('page-table-block', require('./components/microsite-designer/PageTableBlock.vue').default)
Vue.component('page-links-block', require('./components/microsite-designer/PageLinksBlock.vue').default)
Vue.component('algolia-search-modal', require('./components/microsite-designer/AlgoliaSearchModal.vue').default)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
if (window.self !== window.top && window.session_id) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrf;
  axios.defaults.headers.common['X-SESSION-ID'] = window.session_id;
}
const app = new Vue({
  el: '#app',
});

// Add spinner on buttons that we click on to show something is happening on mobile
$(document).ready(() => {
	$('.spin-on-click').click(e => {
	if ($(e.currentTarget).find('.remove-on-back').length == 0)
    	$(e.currentTarget).prepend('<i class="fa fa-fw fa-circle-notch fa-spin remove-on-back"></i>');
  });

  // add session id on all links when in iframe
  if (window.self !== window.top && window.session_id) {
    $('a').each(function() {
      const href = $(this).attr('href');

      // check if href is internal link - continue
      if (href && href.indexOf(window.location.origin) !== 0) {
        return;
      }

      if (href && href.indexOf('?') === -1) {
        $(this).attr('href', href + '?_session=' + window.session_id);
      } else {
        $(this).attr('href', href + '&_session=' + window.session_id);
      }
    });

    // add session id to url - when you click back button, it will be there
    var url = new URL(window.location.href);
    url.searchParams.set('_session', window.session_id);
    window.history.replaceState(null, null, url);
  }
});
$(window).on('unload', function() {
  $('i.remove-on-back').remove();
});
$(window).on('pagehide', function() {
  $('i.remove-on-back').remove();
});
